import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import type { NonDeletedExcalidrawElement } from "@excalidraw/element/types";

import { useAppContext } from "../context/AppContext";

import { PageLayout } from "../components/PageLayout";

import ExcalidrawApp from "./../ExcalidrawApp";

/**
 * Location state type for the EditorPage
 * Contains optional id, name, and shapes for the diagram
 */
type EditorLocationState = {
  id?: string;
  name?: string;
  shapes?: NonDeletedExcalidrawElement[];
};

const EditorPage: React.FC = () => {
  const location = useLocation();
  const state = (location.state || {}) as EditorLocationState;

  const [loading, setLoading] = useState(true);
  const [shapes, setShapes] = useState<NonDeletedExcalidrawElement[]>(
    (state.shapes || []) as NonDeletedExcalidrawElement[],
  );
  const [docId, setDocId] = useState<string | undefined>(state.id);
  const { shape, setShape } = useAppContext();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const templateId = params.get("template");

    // ①テンプレ無し → すぐ描画
    if (!templateId) {
      setShapes(
        (location.state?.shapes || []) as NonDeletedExcalidrawElement[],
      );
      setDocId(state.id);
      setShape((prev) => ({ ...prev, name: state.name || prev.name }));
      setLoading(false);
      return;
    }

    // ②テンプレ有り → 先に fetch
    (async () => {
      try {
        const res = await fetch(`/templates/${templateId}.json`);
        const data = await res.json();
        if (Array.isArray(data.elements)) {
          setShapes(data.elements as NonDeletedExcalidrawElement[]);
        }
        setDocId(undefined);
        setShape((prev) => ({ ...prev, name: "Untitled" }));
      } catch (err) {
        console.error("template load error", err);
      } finally {
        setLoading(false);
      }
    })();
  }, [location, state.id, state.name, state.shapes]);

  return (
    <PageLayout>
      {!loading && (
        <ExcalidrawApp
          initialId={docId}
          initialName={shape.name}
          initialShapes={shapes}
          onMetaChange={(next) => {
            // 例：ExcalidrawApp側で名称変更したときに拾えるように
            if (next.id !== undefined) {
              setDocId(next.id);
            }
            if (next.name !== undefined) {
              setShape((prev) => ({ ...prev, name: next.name ?? prev.name }));
            }
          }}
        />
      )}
    </PageLayout>
  );
};

export default EditorPage;
